import _toConsumableArray from "/builds/vistaprint-org/digital/acquisition/merchandising-components/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import PropTypes from 'prop-types';
import { deprecatedComponent } from '../core/deprecated-component.js';
import { createComponent } from '../core/create-component.js';
import { SWAN_STYLE_KEY_MAP } from '../head/stylesheets.component.js';
var propTypes = {
  /**
  * Renders the banner with the text on the left and image on the right instead of the other way around
  */
  textLeft: PropTypes.bool,

  /**
  * Staggers the banner image on top of the BannerText element
  */
  staggered: PropTypes.bool
};
/**
 * @deprecated Use Standard Hero or Standard Banner
 */

var DetailsBanner = deprecatedComponent({
  displayName: 'DetailsBanner',
  description: 'DetailsBanner is Deprecated. Migrate to Standard Hero or Standard Banner',
  root: createComponent({
    displayName: 'DetailsBanner',
    root: 'div',
    propTypes: propTypes,
    requiredStyleKeys: SWAN_STYLE_KEY_MAP.detailsBanner,
    propConfig: {
      classNames: function classNames(_ref) {
        var textLeft = _ref.textLeft,
            staggered = _ref.staggered;
        var classesSet = new Set(['swan-details-banner']);
        if (textLeft) classesSet.add('swan-details-banner-text-left');
        if (staggered) classesSet = new Set([].concat(_toConsumableArray(classesSet), ['swan-details-banner-background-staggered']));
        return classesSet;
      }
    }
  })
});
DetailsBanner.defaultProps = {
  staggered: false,
  textLeft: false,
  bgShort: true
};
export { DetailsBanner };